<template>
  <div :class="rootClass">
    <b-row>
      <b-tabs style="width: 100%">
        <b-tab title="Tra cứu lịch sử Voice, SMS, Data">
          <b-col cols="12">
            <b-row class="mb-2">
              <b-col lg="3" sm="12">
                <b-row align-v="center">
                  <label :class="rootClass + '__phone-number-label'"
                  >Số thuê bao</label
                  >
                  <b-form-input
                      ref="inputSearchPhone"
                      v-model="searchPhone"
                      :class="rootClass + '__phone-number-input'"
                      v-on:keyup.enter="getGetCdrDetail"
                  ></b-form-input>
                </b-row>
              </b-col>
              <b-col lg="3" sm="12" style="margin-left: -2%;">
                <b-row align-v="center">
                  <label :class="rootClass + '__from-date-label'"
                  >Từ ngày</label
                  >
                  <b-form-datepicker
                      v-model="fromDate"
                      :class="rootClass + '__from-date-input'"
                      :date-format-options="{
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      }"
                      locale="vi-VN"
                      style="font-size: 16px;font-weight: 500 !important;color: black !important;"
                  />
                </b-row>
              </b-col>
              <b-col lg="3" sm="12" style="margin-left: -3%;">
                <b-row align-v="center">
                  <label :class="rootClass + '__to-date-label'"
                  >Đến ngày</label
                  >
                  <b-form-datepicker
                      v-model="toDate"
                      :class="rootClass + '__to-date-input'"
                      :date-format-options="{
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      }"
                      locale="vi-VN"
                      style="font-size: 16px;"
                  />
                </b-row>
              </b-col>
              <b-col lg="2" sm="12" style="display: flex; align-items: center; max-width: 13%;margin-right: 4%">
                <b-button
                    :class="rootClass + '__search-voice-sms-data-btn'"
                    class="redButton"
                    style="margin-left: -30%"
                    variant="danger"
                    @click="getGetCdrDetail()"
                >Tra cứu
                </b-button>
              </b-col>
              <b-col lg="2" sm="12" style="display: flex; align-items: center; max-width: 13%;">
                <b-button
                    :class="rootClass + '__export-voice-sms-data-btn'"
                    class="redButton"
                    variant="danger"
                    @click="exportExcel"
                ><span>
                    <feather-icon class="mr-50" icon="SaveIcon" size="16"
                    /></span>
                  Xuất file
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <span style="color: red">Số lượng bản ghi: {{
                  CdrDetail.length
                }}, tổng dung lượng data: {{ totalDataUse }},
                tổng thời lượng cuộc gọi; {{ totalDuration }}s, tổng tiền tiêu dùng: {{ totalTransactionAmount }}</span>
            </b-row>
            <b-row class="mb-1">
              <table :class="rootClass + '__history-voice-sms-data-table'">
                <tr style="height: 3rem;position: sticky">
                  <template v-for="(h, i) in historyVoiceSMSDataTable.fields">
                    <th
                        :key="h.key"
                        :class="{
                          '--first-th': i === 0,
                          '--last-th':
                            i === historyVoiceSMSDataTable.fields.length - 1,
                        }"
                        style="min-width: 120px"
                    >
                      {{ h.label }}
                    </th>
                  </template>
                </tr>
                <template v-for="(r,index) in CdrDetail" v-if="showErrSearch===false">
                  <tr :key="index" style="color:black;">
                    <td>{{ index + 1 }}</td>
                    <td></td>
                    <td>{{ r.subscriberNumber }}</td>
                    <td>{{ r.otherPartyNumber }}</td>
                    <td>{{ r.tSC }}</td>
                    <td>{{ r.transactionDateTime }}</td>
                    <td>{{ r.duration }}</td>
                    <td>{{ r.transactionAmount }}</td>
                    <td>{{ r.mainAccountBalance }}</td>
                    <td>{{ r.serviceProviderId }}</td>
                    <td>{{ r.serviceIdentifier }}</td>
                    <td>{{ (r.dataVolume / 1048576).toFixed(2) + "MB" }}</td>
                    <td></td>
                    <td>{{ r.serviceClassId }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </template>
              </table>
            </b-row>
            <b-row v-if="showErrSearch" style="justify-content: center;font-size: 18px">
              Không tìm thấy kết quả!
            </b-row>
          </b-col>
        </b-tab>
        <b-tab title="Tra cứu lịch sử Spam">
          <b-col cols="12">
            <b-row class="mb-4">
              <b-col lg="3" sm="12">
                <b-row align-v="center">
                  <label :class="rootClass + '__phone-number-label'"
                  >Số thuê bao</label
                  >
                  <b-form-input
                      :class="rootClass + '__phone-number-input'"
                  ></b-form-input>
                </b-row>
              </b-col>
              <b-col lg="2" sm="12" style="display: flex; align-items: center">
                <b-button
                    :class="rootClass + '__search-spam-btn'"
                    class="redButton"
                    variant="danger"
                >Tra cứu CRS
                </b-button
                >
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <table :class="rootClass + '__history-spam-table'">
                <tr style="height: 3rem; border-bottom: 1px solid #ececec">
                  <template v-for="(h, i) in historySpamTable.fields"
                  >
                    <th
                        :key="i"
                        :class="{
                          '--first-th': i === 0,
                          '--last-th': i === historySpamTable.fields.length - 1,
                        }"
                    >
                      {{ h.label }}
                    </th>
                  </template
                  >
                </tr>
                <template v-for="(r,index) in historySpamTable.items">
                  <tr :key="index">
                    <td
                        v-for="(h, i) in historySpamTable.fields"
                        :key="h"
                        :class="{
                          '--first-td': i === 0,
                          '--last-td': i === historySpamTable.fields.length - 1,
                        }"
                    >
                      {{ r[h.key] }}
                    </td>
                  </tr>
                </template>
              </table>
            </b-row>
            <b-row v-if="showErrSearchSpam" style="justify-content: center;font-size: 18px">
              Không tìm thấy kết quả!
            </b-row>
          </b-col>
        </b-tab>
      </b-tabs>
    </b-row>

  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import DropMenu from "./DropMenu.vue";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment/moment";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BImg,
    BButtonGroup,
    BInputGroup,
    BInputGroupPrepend,
    BTabs,
    BTab,
    BContainer,
    BFormDatepicker,
    DropMenu,
  },
  data() {
    return {
      rootClass: "search-crs",
      fromDate: new Date(),
      toDate: new Date(),
      historyVoiceSMSDataTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "detailt", label: "Chi tiết"},
          {key: "phone", label: "Số thuê bao"},
          {key: "phoneCalled", label: "Số bị gọi"},
          {key: "serviceType", label: "Loại dịch vụ"},
          {key: "dateDeduction", label: "Thời điểm trừ cước"},
          {key: "spanTime", label: "Thời lượng(s)"},
          {key: "packageName", label: "Giá cước"},
          {key: "accountBalance", label: "Số dư TKC sau khi bị trừ"},
          {key: "supplierId", label: "ID nhà cung cấp"},
          {key: "serviceCode", label: "Mã định danh dịch vụ"},
          {key: "usedData", label: "Lượng dữ liệu tiêu dùng"},
          {key: "rootId", label: "ID nút gốc"},
          {key: "serviceClassId", label: "ID lớp dịch vụ"},
          {key: "traffic", label: "Traffic"},
          {key: "locationNu", label: "LocationNu"},
          {key: "cellID", label: "CellID"},
        ]
      },
      historySpamTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "time", label: "Thời gian"},
          {key: "serviceCode", label: "Mã dịch vụ"},
          {key: "operation", label: "Thao tác"},
          {key: "note", label: "Ghi chú"},
          {key: "user", label: "Người dùng"},
        ],
        items: [
          {
            stt: 1,
            time: "19/03/2022 01:01:54",
            serviceCode: "SMO",
            operation: "Khóa",
            note: "SPS Khoa thue bao do SPAM cuoc goi theo yeu cau Bo TTTT-Lan1",
            user: "System",
          },
          {
            stt: 2,
            time: "19/03/2022 01:01:54",
            serviceCode: "SMO",
            operation: "Khóa",
            note: "SPS Khoa thue bao do SPAM cuoc goi theo yeu cau Bo TTTT-Lan1",
            user: "System",
          },
          {
            stt: 3,
            time: "19/03/2022 01:01:54",
            serviceCode: "SMO",
            operation: "Khóa",
            note: "SPS Khoa thue bao do SPAM cuoc goi theo yeu cau Bo TTTT-Lan1",
            user: "System",
          },
        ],
      },
      CdrDetail: [],
      regex087: /87\d{7}$/,
      showErrSearch: false,
      showErrSearchSpam: false,
      totalDuration: 0,
      totalDataUse: 0,
      totalTransactionAmount: 0,
    };
  },
  props: {
    searchPhone: String
  },
  mounted() {
    this.$root.$on("bv::dropdown::show", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on("bv::dropdown::hide", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
    this.getGetCdrDetail();
  },
  computed: {
    // totalDataUse() {
    //   let sum = 0;
    //   this.CdrDetail.forEach((e) => {
    //     if (e.dataVolume > 0) {
    //       sum += parseInt(e.dataVolume)
    //     }
    //   })
    //   return (sum / 1048576).toFixed(2) + "MB"
    // },
    // totalDuration() {
    //   let sum = 0;
    //   this.CdrDetail.forEach((e) => {
    //     if (e.duration > 0) {
    //       sum += parseInt(e.duration)
    //     }
    //   })
    //   return sum
    // },

  },
  methods: {
    formatPhoneNum() {
      if (this.searchPhone.startsWith("0")) {
        this.searchPhone = this.searchPhone.substring(1);
        this.searchPhone = 84 + this.searchPhone;
      }
    },
    getGetCdrDetail() {
      this.showLoading("block")
      this.formatPhoneNum();
      this.fromDate = moment(this.fromDate).format("YYYY-MM-DD")
      this.toDate = moment(this.toDate).format("YYYY-MM-DD")
      if (this.regex087.test(this.searchPhone)) {
        let checkDate = this.checkDate(this.fromDate, this.toDate)
        if (checkDate <= 0) {
          if (checkDate >= -30) {
            useJwt.get('getcdr_detail/?startDate=' + this.fromDate + '&endDate=' + this.toDate + '&type=all&msisdn=' + this.searchPhone).then((response) => {
              this.showLoading("none")
              this.CdrDetail = response.data.result.result;
              this.formattSC();
              this.formatTime();
              if (this.CdrDetail.length > 0) {
                this.showErrSearch = false
                this.countTotalData();
              } else {
                this.showErrSearch = true
              }
              console.log("getSubscriberBalance", response.data.result.result);
            }).catch((error) => {
              this.showLoading("none")
              console.log(error);
            });
          } else {
            this.showLoading("none")
            this.CdrDetail = {}
            this.$toast.error("Thời gian tìm kiếm trong khoảng 30 ngày", {
              position: "top-right",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }
        } else {
          this.showLoading("none")
          this.$toast.error("Ngày bắt đầu phải trước ngày kết thúc", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        }
      } else {
        this.showLoading("none")
        this.$refs.inputSearchPhone.focus()
        if (this.searchPhone === "") {
          this.$toast.error("Vui lòng nhập số thuê bao", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        } else {
          this.$toast.error("Số thuê bao chưa hợp lệ", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        }

      }
    },
    // commit
    exportExcel() {
      this.showLoading("block")
      this.formatPhoneNum();
      this.fromDate = moment(this.fromDate).format("YYYY-MM-DD")
      this.toDate = moment(this.toDate).format("YYYY-MM-DD")
      if (this.regex087.test(this.searchPhone)) {
        let checkDate = this.checkDate(this.fromDate, this.toDate)
        if (checkDate <= 0) {
          if (checkDate >= -30) {
            useJwt.get('excelexport?startDate=' + this.fromDate + '&endDate=' + this.toDate + '&type=all&msisdn=' + this.searchPhone, {
              responseType: 'blob'
            }).then((response) => {
              this.showLoading("none")
              console.log("excelexport", response);
              var fileURL = window.URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              }));
              var fileLink = document.createElement('a');

              fileLink.href = fileURL;
              fileLink.setAttribute('download', this.searchPhone + '-' + this.fromDate + '-' + this.toDate + '.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();
            }).catch((error) => {
              this.showLoading("none")
              console.log(error);
            });
          } else {
            this.showLoading("none")
            this.CdrDetail = {}
            this.$toast.error("Thời gian tìm kiếm trong khoảng 30 ngày", {
              position: "top-right",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }
        } else {
          this.showLoading("none")
          this.$toast.error("Ngày bắt đầu phải trước ngày kết thúc", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        }
      } else {
        this.showLoading("none")
        this.$refs.inputSearchPhone.focus()
        if (this.searchPhone === "") {
          this.$toast.error("Vui lòng nhập số thuê bao", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        } else {
          this.$toast.error("Số thuê bao chưa hợp lệ", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        }

      }
    },
    showLoading(options) {
      document.getElementById('loading-bg').style.display = options;
    },
    formattSC() {
      for (let i = 0; i < this.CdrDetail.length; i++) {
        if (this.CdrDetail[i].tSC === "0") {
          this.CdrDetail[i].tSC = "Thoại"
        }
        if (this.CdrDetail[i].tSC === "4") {
          this.CdrDetail[i].tSC = "SMS"
        }
        if (this.CdrDetail[i].tSC === "6") {
          this.CdrDetail[i].tSC = "Data"
        }
      }
    },
    formatTime() {
      for (let i = 0; i < this.CdrDetail.length; i++) {
        this.CdrDetail[i].transactionDateTime = moment(this.CdrDetail[i].transactionDateTime).format("DD/MM/YYYY HH:mm:ss")
      }
    },
    checkDate(fromDate, toDate) {
      fromDate = moment(this.fromDate)
      toDate = moment(this.toDate)
      return fromDate.diff(toDate, 'days')
    },
    countTotalData() {
      this.totalDataUse = 0
      this.totalDuration = 0
      this.totalTransactionAmount = 0;
      this.CdrDetail.forEach((e) => {
        if (e.dataVolume > 0) {
          this.totalDataUse += parseFloat(e.dataVolume)
        }
        if (e.duration > 0) {
          this.totalDuration += parseInt(e.duration)
        }
        if (e.transactionAmount > 0) {
          this.totalTransactionAmount += parseFloat(e.transactionAmount)
        }
      })
      console.log(this.totalDataUse)
      this.totalDataUse = (this.totalDataUse / 1048576).toFixed(2) + "MB"

    }
  }
};
</script>

<style lang="scss" scoped>
.search-crs {
  position: relative;
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__card {
    border-radius: 2rem;
    background: #fcfcfc;
  }

  &__func-group-btns {
    border: 1px solid red;
    border-radius: 40px;
    height: 38px;
  }

  &__subscriber-information-btn {
    border-radius: 40px;
    font-weight: 800;
    color: #707070 !important;
    background: transparent !important;
    border: transparent;
    padding: 0.2rem 1.5rem;
  }

  &__search-crs-btn {
    border-radius: 40px !important;
    color: white;
    width: 195px;
    padding: 0.2rem 1.5rem;
  }

  &__phone-number-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 80px;
  }

  &__phone-number-input {
    font-weight: 500;
    color: black;
    font-size: 14px;
    width: 200px;
  }

  &__from-date-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__from-date-input {
    width: 200px;
  }

  &__to-date-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__to-date-input {
    width: 200px;
  }

  &__search-voice-sms-data-btn {
    border-radius: 40px;
    //font-size: 10px;
  }

  &__history-voice-sms-data-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;


    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border: 0.299185px solid rgba(184, 184, 184, 0.5);

    }

    th {
      background-color: #ED1F24;
      color: white;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__export-voice-sms-data-btn {
    border-radius: 40px;
  }

  &__search-spam-btn {
    border-radius: 40px;
    font-size: 10px;
  }

  &__history-spam-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border-right: 0.299185px solid rgba(184, 184, 184, 0.5);
      border-left: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    tr td {
      color: black;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__menu-right-group {
    position: absolute;
    top: 60px;
    right: 20px;
  }
}

.redButton {
  background-color: #ED1F24 !important;
  border-color: #ED1F24 !important;
}

@media screen and (max-width: 576px) {
  .search-crs {
    &__phone-number-label {
      width: 100%;
    }

    &__phone-number-input {
      width: 100%;
    }

    &__from-date-label {
      width: 100%;
    }

    &__from-date-input {
      width: 100%;
    }

    &__to-date-label {
      width: 100%;
    }

    &__to-date-input {
      width: 100%;
    }
  }
}
</style>
